export const HIDDEN = "hidden";
export const DETAILED = "detailed";
